import { useField } from 'formik';
import { mix, rgba } from 'polished';
import { Box, BoxProps } from 'reflexbox';
import styled, { css } from 'styled-components';

import { CheckmarkIcon } from '@treams/treams-icons';

import { Spinner } from './Spinner';

const ContainerNormal = css<{ checked?: boolean }>`
	${(props) =>
		props.checked
			? `
		background: ${mix(0.25, props.theme.colors.primary, props.theme.colors.white)};
		border-color: ${mix(0.25, props.theme.colors.primary, props.theme.colors.white)};

		&:hover {
			background: ${mix(0.5, props.theme.colors.primary, props.theme.colors.white)};
			border-color: ${mix(0.5, props.theme.colors.primary, props.theme.colors.white)};
		}
	`
			: `
		&:hover {
			background: ${props.theme.colors.lightBlueLight};
			border-color: ${props.theme.colors.slateBlue};
		}
	`}

	&:focus {
		border-color: ${(props) => props.theme.colors.primary};
		box-shadow: 0px 0px 0px 2px ${(props) => rgba(props.theme.colors.primary, 0.25)};
	}
`;

const ContainerDisabled = css<{ checked?: boolean }>`
	border-color: ${(props) => props.theme.colors.lightBlue};

	${(props) => props.checked && `background: ${props.theme.colors.lightBlue};`}
`;

const Container = styled(Box)<{ checked?: boolean; disabled?: boolean }>`
	width: 24px;
	height: 24px;
	background: white;
	border: 1px solid ${(props) => props.theme.colors.lightBlueDark};
	border-radius: 4px;

	${(props) => (props.disabled ? ContainerDisabled : ContainerNormal)}

	svg {
		display: block;
		width: 24px;
		height: 24px;

		path {
			fill: ${(props) =>
				props.disabled ? props.theme.colors.slateBlue : props.theme.colors.primary};
		}
	}
`;

export function Checkbox(
	props: BoxProps & { checked?: boolean; disabled?: boolean; onClick?: () => void },
) {
	const { checked, disabled, ...rest } = props;

	return (
		<Container tabIndex={-1} checked={checked} disabled={disabled} {...rest}>
			{checked && <CheckmarkIcon />}
		</Container>
	);
}

export function CheckboxFormik(props: { name: string }) {
	const [{ value }, , { setValue }] = useField<boolean>(props.name);

	return <Checkbox checked={value} onClick={() => setValue(!value)} />;
}

Checkbox.Formik = CheckboxFormik;

Checkbox.Skeleton = function CheckboxSkeleton() {
	return (
		<Box p={1}>
			<Spinner />
		</Box>
	);
};
